<template>
  <div class="service-display">
    <div class="serviceMode">
      <div class="base_header_title">服务模式</div>
      <div :class="['service-mode_main', serviceModeClassName]">
        <img :src="require(`@/assets/img/account/${serviceModeIcon}.png`)" alt="" />
        <span v-if="storeAccoutnInfo.isExpire">合约到期</span>
        <span v-else>{{ storeAccoutnInfo.storeTypeDescription }}</span>
      </div>
    </div>
    <div class="service-expire-time">
      <div class="base_header_title">
        <span>服务到期时间</span>
        <span class="contract-tip" v-if="storeAccoutnInfo.hasUnEffectiveContract">新合同5分钟内生效</span>
      </div>
      <div :class="['service-expire-time_main', { warning: expireWarningShow }]">
        <span class="expire-time" v-if="storeAccoutnInfo.endDate">
          {{ storeAccoutnInfo.endDate | baseFormat('YYYY-MM-DD') }}
        </span>
        <span class="expire-time" v-else>服务未开通</span>
        <span v-if="expireWarningShow" class="server-status">
          {{ storeAccoutnInfo.serverStatus | constOptions(serverStatusOption) }}
        </span>
        <p v-if="storeAccoutnInfo.expireTimeInterruptedInfo" class="interrupted-info">
          {{ storeAccoutnInfo.expireTimeInterruptedInfo }}
        </p>
      </div>
      <div class="service-expire-time_bottom" v-if="storeAccoutnInfo.saleMobile && storeAccoutnInfo.saleName">
        如有疑问请联系销售经理：{{ storeAccoutnInfo.saleName }}，电话{{ storeAccoutnInfo.saleMobile }}
      </div>
    </div>
    <div class="serviceLeftMoney">
      <div class="base_header_title">点数余额</div>
      <div :class="['service-left-money_main', serviceLeftMoneyClassName]">
        <span>{{ storeAccoutnInfo.availableAmount || 0 }}</span>
        <b>点</b>
      </div>
      <div class="serviceLeftMoneyBottom">
        <div class="allMoney" @click="goPage(1)">
          <div class="allMoneyTittle">
            累计购买金额
            <div class="question_mark">
              <el-tooltip class="item" effect="dark" content="历史累计购买金额" placement="right">
                <img :src="require('@/assets/img/account/icon_question_mark.png')" alt="" />
              </el-tooltip>
            </div>
            <img class="right_icon" :src="require('@/assets/img/account/r.png')" alt="" />
          </div>
          <div class="allMoneyNum">
            {{ storeAccoutnInfo.totalRechargeAmount / 100 || 0 }}
            <span>元</span>
          </div>
        </div>
        <div class="allUse" @click="goPage(2)">
          <div class="allUseTittle">
            累计消费点数
            <div class="question_mark">
              <el-tooltip class="item" effect="dark" content="合同周期内的累计消费点数" placement="right">
                <img :src="require('@/assets/img/account/icon_question_mark.png')" alt="" />
              </el-tooltip>
            </div>
            <img class="right_icon" :src="require('@/assets/img/account/r.png')" alt="" />
          </div>

          <div class="allUseNum">
            {{ storeAccoutnInfo.totalConsumeCoin || 0 }}
            <span>点</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SERVER_STATUS, serverStatusOption } from '@/lib/constant';
import { baseFormat } from '@fastweb/f2e-utils';

import { constOptions } from '@/util';
export default {
  props: {
    storeAccoutnInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      // 门店账户类型
      storeAccountType: {
        1: '年费会员',
        2: '储值会员',
        3: '试用会员',
        4: '普通会员'
      },
      serverStatusOption
    };
  },
  computed: {
    serviceModeClassName() {
      const { storeType = 0, isExpire } = this.storeAccoutnInfo;
      // 合同到期
      if (isExpire) return 'expire';
      const classNameObj = {
        1: 'annual-fee', // 年费
        2: 'stored-value', // 储值
        3: 'trial', // 试用
        4: 'normal' // 普通
      };
      return classNameObj[storeType] || '';
    },
    serviceModeIcon() {
      const { storeType, isExpire } = this.storeAccoutnInfo;
      // 合同到期
      if (isExpire) return 'expire';
      return `type_${storeType}`;
    },
    serviceLeftMoneyClassName() {
      // 渲染点数余额不同样式
      const { storeAccoutnInfo = {} } = this;
      const { availableAmount } = storeAccoutnInfo;
      if (availableAmount > 10) return 'orange';
      if (availableAmount < 10) return 'red';
      return '';
    },
    expireWarningShow() {
      const { EXPIRE_SOON, EXPIRED } = SERVER_STATUS;
      const { serverStatus = 0 } = this.storeAccoutnInfo;
      return [EXPIRE_SOON, EXPIRED].includes(serverStatus);
    }
  },
  methods: {
    goPage(type) {
      const jumpObj = {
        1: 'addAccountHistory',
        2: 'useAccountHistory'
      };
      this.$router.push(`shopAccount/${jumpObj[type]}`);
    }
  },
  filters: {
    constOptions,
    baseFormat
  }
};
</script>

<style lang="scss" scoped>
.service-display {
  display: flex;
  .right_icon {
    width: 5px;
    height: 8px;
    margin-top: -3px;
  }
  .question_mark {
    width: 12px;
    cursor: pointer;
    margin-right: 4px;
    margin-left: 2px;
    img {
      width: 12px;
      margin-top: 2px;
    }
  }
  .baseHeader {
    padding: 16px;
    margin-bottom: 16px;
    height: 145px;
    overflow-y: auto;
    flex: 1;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
    border-radius: 4px;
    border: 1px solid rgba(242, 242, 242, 1);
  }
  .serviceMode {
    @extend .baseHeader;
    .service-mode_main {
      margin-top: 24px;
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        display: block;
        width: 26px;
        margin-right: 16px;
      }
      span {
        display: block;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .annual-fee {
      span {
        color: #cc9568;
      }
    }
    .stored-value {
      span {
        color: #d4bb3f;
      }
    }
    .trial,
    .normal {
      span {
        color: #8da0b3;
      }
    }
    .expire {
      span {
        color: #e0514c;
      }
    }
  }
  .service-expire-time {
    @extend .baseHeader;
    margin: 0 16px;
    .service-expire-time_main {
      margin-top: 12px;
      &.warning {
        color: #df3933;
      }
      width: 100%;
      text-align: center;
      span {
        font-size: 18px;
        font-weight: 500;
        margin-right: 12px;
      }
      b {
        color: #bdbdbd;
        font-size: 14px;
      }
      .interrupted-info {
        font-size: 12px;
        color: #df3933;
      }
    }
    .large {
      span {
        color: #1e8dff;
      }
    }
    .mid {
      span {
        color: #ebb436;
      }
    }
    .sm {
      span {
        color: #e0514c;
      }
    }
    .service-expire-time_bottom {
      margin-top: 12px;
      color: rgba(189, 189, 189, 1);
      font-size: 12px;
      text-align: center;
      width: 100%;
    }
  }
  .serviceLeftMoney {
    @extend .baseHeader;
    .service-left-money_main {
      margin-top: 12px;
      width: 100%;
      text-align: center;
      top: 47px;
      span {
        font-weight: bold;
        font-size: 22px;
        margin-right: 12px;
      }
      b {
        font-size: 14px;
        color: #bdbdbd;
      }
    }
    .green {
      span {
        color: #1e8dff;
      }
    }
    .orange {
      span {
        color: #ebb436;
      }
    }
    .red {
      span {
        color: #e0514c;
      }
    }
    .serviceLeftMoneyBottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .allMoney {
        cursor: pointer;
        .allMoneyTittle {
          display: flex;
          font-size: 12px;
          color: #707070;
          align-items: center;
          &:hover {
            text-decoration: underline;
          }
        }
        .allMoneyNum {
          padding-top: 1px;
          font-size: 14px;
          color: #707070;
          font-weight: bold;
          span {
            font-size: 12px;
            color: #707070;
          }
        }
      }
      .allUse {
        cursor: pointer;
        .allUseTittle {
          display: flex;
          font-size: 12px;
          color: #707070;
          align-items: center;
          &:hover {
            text-decoration: underline;
          }
        }
        .allUseNum {
          padding-top: 1px;
          font-size: 14px;
          color: #707070;
          font-weight: bold;
          span {
            font-size: 12px;
            color: #707070;
          }
        }
      }
    }
  }
  .base_header_title {
    font-weight: bold;
    color: rgba(36, 36, 36, 1);
    font-size: 14px;
    .contract-tip {
      display: inline-block;
      margin-left: 4px;
      padding: 4px;
      background: #ebf8ff;
      font-size: 12px;
      color: #1e8dff;
      border-radius: 2px;
    }
  }
}
</style>
